import type { Dispatch } from "react";
import type { EngineSnapshot } from "@retreats/engine";
import type { UIAction } from "../bridge/types";
import { RetreatState } from "../bridge/types";
import { useWakeLock } from "./useWakeLock";
import { useAppBadge } from "./useAppBadge";
import { useMediaSession } from "./useMediaSession";
type LiveInfo = Parameters<typeof useMediaSession>[0];
import { useServiceWorkerUpdate } from "./useServiceWorkerUpdate";
import { useLifecycleBoot } from "./useLifecycleBoot";
import { useInstallNudge } from "./useInstallNudge";
import { useBeforeUnload } from "./useBeforeUnload";
import { useSilentAudio } from "./useSilentAudio";

export function useRetreatDeviceIntegration(
  snapshot: EngineSnapshot,
  liveInfo: LiveInfo | undefined,
  dispatchUI: Dispatch<UIAction>,
  isFirstLaunch: boolean,
  demo: boolean,
  testEngine: boolean,
) {
  const isRunning = snapshot.status === RetreatState.RUNNING;

  useWakeLock(isRunning);
  useAppBadge(snapshot.status);
  useMediaSession(liveInfo);
  useSilentAudio(isRunning);
  useBeforeUnload(isRunning);
  useLifecycleBoot(dispatchUI, demo, testEngine);

  const { needsRefresh: swUpdatePending, applyUpdate: applySwUpdate } =
    useServiceWorkerUpdate();

  const installHandlers = useInstallNudge(dispatchUI, isFirstLaunch, demo);

  return { swUpdatePending, applySwUpdate, installHandlers };
}
